import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Contact from "./pages/Contact";
import Resources from "./pages/Resources";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import BlackbirdAI from "./pages/BlackbirdAI";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import Glossary from "./pages/Glossary";
import FAQ from "./pages/FAQ";
import ITARvsEAR from "./pages/comparisons/ITARvsEAR";
import ECCNvsHTS from "./pages/comparisons/ECCNvsHTS";
import LicenseExceptionVsValidated from "./pages/comparisons/LicenseExceptionVsValidated";
import FTZvsBondedWarehouse from "./pages/comparisons/FTZvsBondedWarehouse";
import ScheduleBvsHTS from "./pages/comparisons/ScheduleBvsHTS";
import DownloadableResources from "./pages/DownloadableResources";
import AerospaceTrade from "./pages/industries/AerospaceTrade";
import MedicalDevices from "./pages/industries/MedicalDevices";
import Electronics from "./pages/industries/Electronics";
import Automotive from "./pages/industries/Automotive";
import Industrial from "./pages/industries/Industrial";
import ProductClassification from "./pages/services/ProductClassification";
import ExportControls from "./pages/services/ExportControls";
import ForeignTradeZones from "./pages/services/ForeignTradeZones";
import VoluntaryDisclosures from "./pages/services/VoluntaryDisclosures";
import TradeManagement from "./pages/services/TradeManagement";
import TrainingAudits from "./pages/services/TrainingAudits";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/product-classification" element={<ProductClassification />} />
          <Route path="/services/export-controls" element={<ExportControls />} />
          <Route path="/services/foreign-trade-zones" element={<ForeignTradeZones />} />
          <Route path="/services/voluntary-disclosures" element={<VoluntaryDisclosures />} />
          <Route path="/services/trade-management" element={<TradeManagement />} />
          <Route path="/services/training-audits" element={<TrainingAudits />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:id" element={<BlogPost />} />
          <Route path="/blackbird-ai" element={<BlackbirdAI />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/glossary" element={<Glossary />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/itar-vs-ear" element={<ITARvsEAR />} />
          <Route path="/eccn-vs-hts" element={<ECCNvsHTS />} />
          <Route path="/license-exception-vs-validated" element={<LicenseExceptionVsValidated />} />
          <Route path="/ftz-vs-bonded-warehouse" element={<FTZvsBondedWarehouse />} />
          <Route path="/schedule-b-vs-hts" element={<ScheduleBvsHTS />} />
          <Route path="/downloadable-resources" element={<DownloadableResources />} />
          <Route path="/industries/aerospace" element={<AerospaceTrade />} />
          <Route path="/industries/medical-devices" element={<MedicalDevices />} />
          <Route path="/industries/electronics" element={<Electronics />} />
          <Route path="/industries/automotive" element={<Automotive />} />
          <Route path="/industries/industrial" element={<Industrial />} />
        </Routes>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
